import { type Person } from '@clubspark-node/clubspark-tennis-types';

import { type StaffData } from 'components/tables/staffTable/types';
import { PersonRepositoryImpl } from 'repository/grapqhlRepository/personRepository';
import { type CloudResult, type RepositoryCacheType } from 'repository/repository';
import type PersonService from 'services/person/personService';
import { displayErrorMessage } from 'services/utils';
import { type CombinedEventEligibility, type EventEligibility } from 'typedefs/event';

export default class PersonServiceImpl implements PersonService {
  personRepository = new PersonRepositoryImpl();

  async getPersonEventEligibility(
    personCsIds: string[],
    tournamentId: string,
    eventId: string,
    cache?: RepositoryCacheType,
  ): Promise<CloudResult<EventEligibility>> {
    const personsEligibility = await this.personRepository.getPersonEventEligibility(
      personCsIds,
      tournamentId,
      eventId,
      cache,
    );

    // show toaster with error message if it exists
    displayErrorMessage<EventEligibility>(personsEligibility);

    return Promise.resolve(personsEligibility);
  }

  async getPersonCombinedEventEligibility(
    participantIdPairs: string[][],
    eventId: string,
    cache: RepositoryCacheType,
  ): Promise<CloudResult<CombinedEventEligibility>> {
    const personCombinedEligibility = await this.personRepository.getPersonCombinedEventEligibility(
      participantIdPairs,
      eventId,
      cache,
    );

    // show toaster with error message if it exists
    displayErrorMessage<CombinedEventEligibility>(personCombinedEligibility);

    return Promise.resolve(personCombinedEligibility);
  }

  async getPlayerProfile(
    personId: string,
    tournamentId: string,
    cache?: RepositoryCacheType,
  ): Promise<CloudResult<Person>> {
    const playerProfile = await this.personRepository.get(personId, tournamentId, cache);

    // show toaster with error message if it exists
    displayErrorMessage<Person>(playerProfile);

    return Promise.resolve(playerProfile);
  }

  async getTournamentStaff(id: string, cache?: RepositoryCacheType): Promise<CloudResult<StaffData[]>> {
    const staff = await this.personRepository.getTournamentStaff(id, cache);

    // show toaster with error message if it exists
    displayErrorMessage<StaffData[]>(staff);

    return Promise.resolve(staff);
  }

  async saveAssistant(tournamentId: string, userId: string): Promise<CloudResult<StaffData>> {
    const saveAssistantResult = await this.personRepository.saveAssistant(tournamentId, userId);

    // show toaster with error message if it exists
    displayErrorMessage<StaffData>(saveAssistantResult);

    return Promise.resolve(saveAssistantResult);
  }
  async removeAssistant(tournamentId: string, userId: string): Promise<CloudResult<StaffData>> {
    const removeAssistantResult = await this.personRepository.removeAssistant(tournamentId, userId);

    // show toaster with error message if it exists
    displayErrorMessage<StaffData>(removeAssistantResult);

    return Promise.resolve(removeAssistantResult);
  }
}
